import { render, staticRenderFns } from "./act.vue?vue&type=template&id=500c8157&scoped=true&"
import script from "./act.vue?vue&type=script&lang=js&"
export * from "./act.vue?vue&type=script&lang=js&"
import style0 from "./act.vue?vue&type=style&index=0&id=500c8157&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c8157",
  null
  
)

export default component.exports